import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { superAdminHttpRoutes, superAdminHttpVersion } from '../../../consts/super_admin_http_routes';
import { ApiService } from '../api.services';
import { HttpParams } from '@angular/common/http';
import { SuperadminEditRequest, SuperadminRequest } from '../../../models/superadmin.model';

@Injectable({
    providedIn: 'root'
})
export class SuperadminService {

    private baseUrl: string = superAdminHttpVersion.V1;

    constructor(private apiService: ApiService) {
    }

    filter(q: string, page_number?: number, page_size?: number): Observable<any> {
        let params = new HttpParams();
        params = params.set('q', q);
        if (page_number) {
            params = params.set('page_number', page_number);
        }
        if (page_size) {
            params = params.set('page_size', page_size);
        }
        return this.apiService.httpGetCall(`${this.baseUrl}${superAdminHttpRoutes.SUPERADMIN_GET_TABLE}`, params);
    }

    register(superadmin: SuperadminRequest): Observable<any> {
        return this.apiService.httpPostCall(`${this.baseUrl}${superAdminHttpRoutes.SUPERADMIN_ADD_EDIT}`, superadmin)
    }

    updateSuperadmin(superadminId: any, superadmin: SuperadminEditRequest): Observable<any> {
        return this.apiService.httpPutCall(`${this.baseUrl}${superAdminHttpRoutes.SUPERADMIN_ADD_EDIT}/${superadminId}`, superadmin)
    }

    deactivate(superAdminId: string): Observable<any> {
        return this.apiService.httpPatchCall(`${this.baseUrl}superadmin/${superAdminId}/status `, {
            "status": "Inactive"
        });
    }

    activate(superAdminId: string): Observable<any> {
        return this.apiService.httpPatchCall(`${this.baseUrl}superadmin/${superAdminId}/status`, {
            "status": "Active"
        });
    }

    loginHistoryFilter(q: string, page_number?: number, page_size?: number): Observable<any> {
        let params = new HttpParams();
        params = params.set('q', q);
        if (page_number) {
            params = params.set('page_number', page_number);
        }
        if (page_size) {
            params = params.set('page_size', page_size);
        }
        return this.apiService.httpGetCall(`${this.baseUrl}${superAdminHttpRoutes.LOGIN_HISTORY_GET_TABLE}`, params);
    }


    getSuperadminHistory(start: number): Observable<any> {       
        return this.apiService.httpPostCall(`${this.baseUrl}${superAdminHttpRoutes.SUPERADMIN_HISTORY_GET_TABLE}`, { start: start })
    }
    getCategoriesHistory(start: number): Observable<any> {
        return this.apiService.httpPostCall(`${this.baseUrl}${superAdminHttpRoutes.GET_CATEGORY_HISTORY}`, { start: start })
    }




}